import React from 'react';
import Nav from '../CreatorComponents/Nav';
import Container from '../CreatorComponents/Container';
import {
  useToolsContext,
  ToolsPanelProvider,
} from './hooks/ToolsPanelProvider';
import ToolsPanel from '../CreatorComponents/ToolsPanel';
import OnboardingDialog from '../CreatorComponents/OnboardingDialog';
import { useSettings } from './contexts/settings/useSettings';

const Screen = ({ children }) => {
  const { open, handleOpenChange } = useToolsContext();
  const { theme } = useSettings();

  console.log('Screen render:', {
    hasChildren: !!children,
    childrenType: children?.type?.name || children?.type?.displayName,
    childrenCount: React.Children.count(children),
    childrenArray: React.Children.map(children, child => ({
      type: child?.type?.name || child?.type?.displayName,
      props: Object.keys(child?.props || {})
    }))
  });

  return (
    <div style={{ 
      minHeight: '100vh', 
      width: '100%', 
      display: 'flex', 
      flexDirection: 'column',
      padding: '20px',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        flex: 1,
        width: '100%',
        position: 'relative'
      }}>
        {children}
      </div>
    </div>
  );
};

export default Screen; 